module.exports = __webpack_public_path__ + "img/polygon.o.3297a9d2.png";